import { render, staticRenderFns } from "./StartYourJourneyForFree.vue?vue&type=template&id=1fe3193e&"
import script from "./StartYourJourneyForFree.vue?vue&type=script&lang=js&"
export * from "./StartYourJourneyForFree.vue?vue&type=script&lang=js&"
import style0 from "./StartYourJourneyForFree.vue?vue&type=style&index=0&id=1fe3193e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports